// Generated by purs version 0.15.15
var LineCapButt = /* #__PURE__ */ (function () {
    function LineCapButt() {

    };
    LineCapButt.value = new LineCapButt();
    return LineCapButt;
})();
var LineCapSquare = /* #__PURE__ */ (function () {
    function LineCapSquare() {

    };
    LineCapSquare.value = new LineCapSquare();
    return LineCapSquare;
})();
var LineCapRound = /* #__PURE__ */ (function () {
    function LineCapRound() {

    };
    LineCapRound.value = new LineCapRound();
    return LineCapRound;
})();
var showStrokeLineCap = {
    show: function (v) {
        if (v instanceof LineCapButt) {
            return "LineCapButt";
        };
        if (v instanceof LineCapSquare) {
            return "LineCapSquare";
        };
        if (v instanceof LineCapRound) {
            return "LineCapRound";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineCap (line 16, column 10 - line 19, column 35): " + [ v.constructor.name ]);
    }
};
var printStrokeLineCap = function (v) {
    if (v instanceof LineCapButt) {
        return "butt";
    };
    if (v instanceof LineCapSquare) {
        return "square";
    };
    if (v instanceof LineCapRound) {
        return "round";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.StrokeLineCap (line 22, column 22 - line 25, column 26): " + [ v.constructor.name ]);
};
var eqStrokeLineCap = {
    eq: function (x) {
        return function (y) {
            if (x instanceof LineCapButt && y instanceof LineCapButt) {
                return true;
            };
            if (x instanceof LineCapSquare && y instanceof LineCapSquare) {
                return true;
            };
            if (x instanceof LineCapRound && y instanceof LineCapRound) {
                return true;
            };
            return false;
        };
    }
};
export {
    LineCapButt,
    LineCapSquare,
    LineCapRound,
    printStrokeLineCap,
    eqStrokeLineCap,
    showStrokeLineCap
};
